import { useState, useEffect, useRef } from 'react';

const useLocalTime = (lang) => {
  const [localTime, setLocalTime] = useState('');
  const [destTime, setDestTime] = useState('');
  const destTimezone = useRef(null);

  useEffect(() => {
    const locale = lang === 'ja' ? 'ja-JP' : lang === 'ko' ? 'ko-KR' : lang.startsWith('zh') ? 'zh-HK' : 'en-US';
    const opts = { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
    const tick = () => {
      setLocalTime(new Date().toLocaleTimeString(locale, opts));
      if (destTimezone.current) {
        try {
          setDestTime(new Date().toLocaleTimeString(locale, { ...opts, timeZone: destTimezone.current }));
        } catch { setDestTime(''); }
      }
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [lang]);

  return { localTime, destTime, destTimezone };
};

export default useLocalTime;
